/**
 * Creates or updates a cookie
 * @param {String} name The cookie name
 * @param {*} value The cookie value
 * @param {Number} days Number of days until the cookie expires
 */
const setCookie = function (name, value, days) {
    const d = new Date()
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000)
    let expires = `expires=${d.toUTCString()}`
    document.cookie = `${name}=${value};${expires};path=/`
}

/**
 * Gets a cookie value
 * @param {String} name The cookie name
 * @returns {String} The cookie value
 */
const getCookie = function (name) {
    name += '='
    const decodedCookie = decodeURIComponent(document.cookie)
    let ca = decodedCookie.split(';')
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i]
        while (c.charAt(0) == ' ') {
            c = c.substring(1)
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length)
        }
    }
    return ''
}

const copyToClipboard = (str) => {
    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(str)
    }
    return copyToClipboardLegacy(str)
}

const copyToClipboardLegacy = (str) => {
    const el = document.createElement('textarea')
    el.value = str
    el.setAttribute('readonly', '')
    el.style.position = 'absolute'
    el.style.left = '-9999px'
    document.body.appendChild(el)
    el.select()
    // el.setSelectionRange(0, str.length);
    const success = document.execCommand('copy')
    document.body.removeChild(el)
    if (success) {
        return Promise.resolve()
    }
    return Promise.reject('Could not execute "copy" comand')
}

const getRequestFullscreenPolyfill = () => {
    const docEl = document.documentElement
    return (
        docEl.requestFullscreen ||
        docEl.mozRequestFullScreen ||
        docEl.webkitRequestFullScreen ||
        docEl.msRequestFullscreen
    )
}

const requestFullScreen = () => {
    const requestFullScreen = getRequestFullscreenPolyfill()

    if (requestFullScreen) {
        return Promise.resolve(requestFullScreen.call(document.documentElement))
    }
    return Promise.reject('FullScreen API is not supported in this browser')
}

/**
 * Locks the screen orientation
 * @param {ScreenOrientationLockType} orientation - The orientation to lock
 * @returns {Promise} A promise that resolves when the orientation is locked
 */
const lockScreenOrientation = (orientation) => {
    if ('orientation' in screen && 'lock' in screen.orientation) {
        return screen.orientation.lock(orientation)
    }
    return Promise.reject('ScreenOrientation API is not supported in this browser')
}

export { setCookie, getCookie, copyToClipboard, requestFullScreen, lockScreenOrientation }
